import React from 'react';
import { Wrapper, Icon, Title } from './styled';
import { useActiveLink } from './hooks';
export var Module = function (_a) {
    var app = _a.app;
    var isActive = useActiveLink(app.link).isActive;
    return (React.createElement(Wrapper, { active: isActive, href: app.link },
        React.createElement(Icon, { src: app.icon.file, alt: app.icon.fileName }),
        React.createElement(Title, null, app.name)));
};
//# sourceMappingURL=Module.js.map